export default "__VITE_ASSET__D_Efz9UT__"